module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG92865307e079109c55ce86e1a50a1141.92865307.png";